import { render, staticRenderFns } from "./DishSelect.vue?vue&type=template&id=508c5032&scoped=true&"
import script from "./DishSelect.vue?vue&type=script&lang=js&"
export * from "./DishSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508c5032",
  null
  
)

export default component.exports